import React from 'react';
import { connect } from 'react-redux';
import Component from './Component';
import { login } from '../actions/UserActions';
import brain from '../assets/images/brain.svg';
import config from '../config.json';
import '../styles/auth.css';

class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.googleButtonRef = React.createRef();
  }

  componentDidMount() {
    this.initialiseGoogleSignIn();
  }

  initialiseGoogleSignIn = () => {
    if (window.google) {
      try {
        window.google.accounts.id.initialize({
          client_id: config.google.client_id,
          callback: this.handleCredentialResponse
        });

        window.google.accounts.id.renderButton(
          this.googleButtonRef.current,
          {
            theme: 'filled_blue',
            size: 'large',
            text: 'signin_with',
            shape: 'rectangular'
          }
        );
      } catch (err) {
        console.error('Error initializing Google Sign-In:', err);
      }
      
    } else {
      // Retry if Google script not loaded yet
      setTimeout(this.initialiseGoogleSignIn, 100);
    }
  };

  handleCredentialResponse = (response) => {
    // response.credential is the Google ID token
    this.props.login(response.credential);
  };

  render() {
    const { isLoggingIn, error } = this.props;

    return (
      <div className="login-container">
        <div className="login-card">
          <img src={brain} className="login-logo" alt="Cerebral Cereal" />
          <h1>Cerebral Cereal</h1>
          <p className="login-subtitle">Please sign in to continue</p>

          <div ref={this.googleButtonRef} className="google-button-container" />

          {isLoggingIn && <p className="login-loading">Signing in...</p>}

          {error && (
            <div className="login-error">
              <strong>Error:</strong> {error}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoggingIn: state.user.isLoggingIn,
  error: state.user.error
});

const mapDispatchToProps = { login };

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
